import { motion } from "framer-motion";
import { Music } from "lucide-react";
import { SectionHeading } from "./Story";

export const Community = ({ community }) => {
  if (!community) return null;
  const scrollToRsvp = () => document.getElementById("rsvp")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="community" className="py-20 sm:py-28 lg:py-32 bg-[var(--surface)]" data-testid="community-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-8 lg:px-16 text-center">
        <SectionHeading script={community.subtitle} title={community.title} testid="community-heading" />
        <motion.p
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }}
          className="text-[var(--text-secondary)] text-base sm:text-lg leading-relaxed max-w-2xl mx-auto"
        >
          {community.description}
        </motion.p>

        <div className="mt-8 flex flex-wrap justify-center gap-3" data-testid="community-activities">
          {(community.activities || []).map((a, i) => (
            <motion.span
              key={i}
              initial={{ opacity: 0, scale: 0.9 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ duration: 0.4, delay: i * 0.06 }}
              className="rounded-full px-4 py-2 text-sm border border-[var(--border-gold)] bg-[var(--card)] text-[var(--text-primary)] flex items-center gap-2"
            >
              <Music className="w-4 h-4 text-[var(--gold)]" /> {a}
            </motion.span>
          ))}
        </div>

        {community.nudge && (
          <p className="mt-9 font-serif italic text-xl sm:text-2xl text-[var(--burgundy)] max-w-2xl mx-auto">{community.nudge}</p>
        )}

        <button
          onClick={scrollToRsvp}
          data-testid="community-cta"
          className="mt-6 rounded-full px-8 py-3 text-sm font-medium transition-all hover:scale-105 shadow-md"
          style={{ backgroundColor: "var(--gold)", color: "var(--on-gold)" }}
        >
          Count me in — I'll RSVP
        </button>
      </div>
    </section>
  );
};
